import React from "react";
import { Chip } from "@mui/material";
import { MdPending, MdCheckCircle, MdCancel } from "react-icons/md";

const statusConfig = {
  pending: {
    label: "Pending",
    color: "warning", // MUI chip color
    icon: <MdPending size={18} />,
  },
  accepted: {
    label: "Accepted",
    color: "success",
    icon: <MdCheckCircle size={18} />,
  },
  rejected: {
    label: "Rejected",
    color: "error",
    icon: <MdCancel size={18} />,
  },
};

const TemplateStatusChip = ({ status }) => {
  const config = statusConfig[status] || statusConfig["pending"]; // fallback to pending
  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      variant="outlined"
      sx={{
        fontWeight: 500,
        fontSize: "0.85rem",
        borderRadius: "12px",
        "& .MuiChip-icon": {
          fontSize: "1rem",
        },
      }}
    />
  );
};

export default TemplateStatusChip;
